// // src/components/userContext.js
// import React, { createContext, useState, useEffect } from "react";

// export const UserContext = createContext();

// export const UserProvider = ({ children }) => {
//     const [user, setUser] = useState(null);
//     const [isUserLoaded, setIsUserLoaded] = useState(false);

//     useEffect(() => {
//         const storedUser = localStorage.getItem("user");
//         if (storedUser) {
//             // Optionally, normalize property names.
//             const parsedUser = JSON.parse(storedUser);
//             setUser({
//                 ...parsedUser,
//                 userType: parsedUser.usertype || parsedUser.userType, // prefer 'usertype'
//             });
//         }
//         setIsUserLoaded(true);
//     }, []);

//     useEffect(() => {
//         if (!user) {
//             fetch("/current-user", { credentials: "include" })
//                 .then((res) => res.json())
//                 .then((data) => {
//                     if (data && data.user) {
//                         // Normalize the type so that our components can always use userType.
//                         const newUser = {
//                             ...data.user,
//                             userType: data.user.usertype || data.user.userType,
//                         };
//                         setUser(newUser);
//                         localStorage.setItem("user", JSON.stringify(newUser));
//                     }
//                     setIsUserLoaded(true);
//                 })
//                 .catch((err) => {
//                     console.error("Error fetching user details:", err);
//                     setIsUserLoaded(true);
//                 });
//         }
//     }, [user]);

//     const updateUser = (newUser) => {
//         setUser(newUser);
//         localStorage.setItem("user", JSON.stringify(newUser));
//     };

//     const logoutUser = () => {
//         setUser(null);
//         localStorage.removeItem("user");
//     };

//     const userId =
//         user && (user._id || user.id) ? (user._id || user.id).toString() : null;

//     return (
//         <UserContext.Provider value={{ user, userId, updateUser, logoutUser, isUserLoaded }}>
//             {children}
//         </UserContext.Provider>
//     );
// };



// // first update after restoration of web
// import React, { createContext, useState, useEffect } from "react";
// import { backendUrl } from "./config";

// export const UserContext = createContext();

// export const UserProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [isUserLoaded, setIsUserLoaded] = useState(false);

//   // On first mount, restore from localStorage or fetch session from server
//   useEffect(() => {
//     const stored = localStorage.getItem("user");
//     if (stored) {
//       const parsed = JSON.parse(stored);
//       setUser({
//         ...parsed,
//         userType: parsed.usertype || parsed.userType,
//       });
//       setIsUserLoaded(true);
//     } else {
//       fetch(`${backendUrl}/current-user`, { credentials: "include" })
//         .then((res) => res.json())
//         .then(({ user: srvUser }) => {
//           if (srvUser) {
//             const normalized = {
//               ...srvUser,
//               userType: srvUser.usertype || srvUser.userType,
//             };
//             setUser(normalized);
//             localStorage.setItem("user", JSON.stringify(normalized));
//           }
//           setIsUserLoaded(true);
//         })
//         .catch((err) => {
//           console.error("Error fetching user details:", err);
//           setIsUserLoaded(true);
//         });
//     }
//   }, []);

//   // Persist a new user object
//   const updateUser = (newUser) => {
//     setUser(newUser);
//     localStorage.setItem("user", JSON.stringify(newUser));
//   };

//   // Call backend to clear session, then clear client state
//   const logoutUser = async () => {
//     try {
//       await fetch(`${backendUrl}/signout`, {
//         method: "POST",
//         credentials: "include",
//       });
//     } catch (e) {
//       console.warn("Signout request failed:", e);
//     }
//     setUser(null);
//     localStorage.removeItem("user");
//   };

//   // Derive userId for convenience
//   const userId =
//     user && (user._id || user.id) ? (user._id || user.id).toString() : null;

//   return (
//     <UserContext.Provider
//       value={{ user, userId, updateUser, logoutUser, isUserLoaded }}
//     >
//       {children}
//     </UserContext.Provider>
//   );
// };










// import { createContext, useState, useEffect } from "react";
// import { backendUrl } from "./config";

// export const UserContext = createContext();

// export const UserProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [isUserLoaded, setIsUserLoaded] = useState(false);

//   const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

//   useEffect(() => {
//     // CHANGE: detect actual browser timeZone
//     const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

//     const stored = localStorage.getItem("user");
//     if (stored) {
//       try {
//         const parsed = JSON.parse(stored);
//         const normalized = {
//           ...parsed,
//           userType: parsed.usertype || parsed.userType,
//             timeZone: parsed.timeZone   || clientTimeZone,
//         };
//         setUser(normalized);
//       } catch {
//         localStorage.removeItem("user");
//       }
//       setIsUserLoaded(true);
//     } else {
//       fetch(`${backendUrl}/current-user`, { credentials: "include" })
//         .then((res) => {
//           if (!res.ok) throw new Error("Not authenticated");
//           return res.json();
//         })
//         .then(({ user: srvUser }) => {
//           if (srvUser) {
//             const normalized = {
//               ...srvUser,
//               userType: srvUser.usertype || srvUser.userType,
//               timeZone:
//                 srvUser.timeZone && srvUser.timeZone !== "UTC"
//                   ? srvUser.timeZone
//                   : browserTz,
//             };
//             setUser(normalized);
//             localStorage.setItem("user", JSON.stringify(normalized));
//           }
//         })
//         .catch((err) => {
//           console.warn("Error fetching current user:", err);
//         })
//         .finally(() => setIsUserLoaded(true));
//     }
//   }, []);

//   const updateUser = (newUser) => {
//     const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
//     const normalized = {
//       ...newUser,
//       userType: newUser.usertype || newUser.userType,
//       timeZone: newUser.timeZone   || clientTimeZone,
//     };
//     setUser(normalized);
//     localStorage.setItem("user", JSON.stringify(normalized));
//   };

//   const logoutUser = async () => {
//     try {
//       await fetch(`${backendUrl}/signout`, {
//         method: "POST",
//         credentials: "include",
//       });
//     } catch (e) {
//       console.warn("Signout request failed:", e);
//     }
//     setUser(null);
//     localStorage.removeItem("user");
//   };

//   const userId =
//     user && (user._id || user.id) ? String(user._id || user.id) : null;

//   return (
//     <UserContext.Provider
//       value={{ user, userId, updateUser, logoutUser, isUserLoaded }}
//     >
//       {children}
//     </UserContext.Provider>
//   );
// };











// import { createContext, useState, useEffect } from "react";
// import { backendUrl } from "./config";

// export const UserContext = createContext();

// export const UserProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [isUserLoaded, setIsUserLoaded] = useState(false);

//   const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

//   useEffect(() => {
//     // CHANGE: detect actual browser timeZone
//     const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

//     const stored = localStorage.getItem("user");
//     if (stored) {
//       try {
//         const parsed = JSON.parse(stored);
//         const normalized = {
//           ...parsed,
//           userType: parsed.usertype || parsed.userType,
//             timeZone: parsed.timeZone   || clientTimeZone,
//         };
//         setUser(normalized);
//       } catch {
//         localStorage.removeItem("user");
//       }
//       setIsUserLoaded(true);
//     } else {
//       fetch(`${backendUrl}/current-user`, { credentials: "include" })
//         .then((res) => {
//           if (!res.ok) throw new Error("Not authenticated");
//           return res.json();
//         })
//         .then(({ user: srvUser }) => {
//           if (srvUser) {
//             const normalized = {
//               ...srvUser,
//               userType: srvUser.usertype || srvUser.userType,
//               timeZone:
//                 srvUser.timeZone && srvUser.timeZone !== "UTC"
//                   ? srvUser.timeZone
//                   : browserTz,
//             };
//             setUser(normalized);
//             localStorage.setItem("user", JSON.stringify(normalized));
//           }
//         })
//         .catch((err) => {
//           console.warn("Error fetching current user:", err);
//         })
//         .finally(() => setIsUserLoaded(true));
//     }
//   }, []);

//   const updateUser = (newUser) => {
//     const browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
//     const normalized = {
//       ...newUser,
//       userType: newUser.usertype || newUser.userType,
//       timeZone: newUser.timeZone   || clientTimeZone,
//     };
//     setUser(normalized);
//     localStorage.setItem("user", JSON.stringify(normalized));
//   };

//   const logoutUser = async () => {
//     try {
//       await fetch(`${backendUrl}/signout`, {
//         method: "POST",
//         credentials: "include",
//       });
//     } catch (e) {
//       console.warn("Signout request failed:", e);
//     }
//     setUser(null);
//     localStorage.removeItem("user");
//   };

//   const userId =
//     user && (user._id || user.id) ? String(user._id || user.id) : null;

//   return (
//     <UserContext.Provider
//       value={{ user, userId, updateUser, logoutUser, isUserLoaded }}
//     >
//       {children}
//     </UserContext.Provider>
//   );
// };









// import { createContext, useState, useEffect } from "react";
// import { backendUrl } from "./config";

// export const UserContext = createContext();

// export const UserProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [isUserLoaded, setIsUserLoaded] = useState(false);

//   const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

//   const normalizeUser = (rawUser) => {
//     return {
//       ...rawUser,
//       userType: rawUser.usertype || rawUser.userType,
//       timeZone: rawUser.timeZone && rawUser.timeZone !== "UTC" ? rawUser.timeZone : clientTimeZone,
//       id: rawUser._id || rawUser.id
//     };
//   };

//   useEffect(() => {
//     const stored = localStorage.getItem("user");
//     if (stored) {
//       try {
//         const parsed = JSON.parse(stored);
//         const normalized = normalizeUser(parsed);
//         setUser(normalized);
//       } catch {
//         localStorage.removeItem("user");
//       }
//       setIsUserLoaded(true);
//     } else {
//       fetch(`${backendUrl}/current-user`, { credentials: "include" })
//         .then((res) => {
//           if (!res.ok) throw new Error("Not authenticated");
//           return res.json();
//         })
//         .then(({ user: srvUser }) => {
//           if (srvUser) {
//             const normalized = normalizeUser(srvUser);
//             setUser(normalized);
//             localStorage.setItem("user", JSON.stringify(normalized));
//           }
//         })
//         .catch((err) => {
//           console.warn("Error fetching current user:", err);
//         })
//         .finally(() => setIsUserLoaded(true));
//     }
//   }, []);

//   const updateUser = (newUser) => {
//     const normalized = normalizeUser(newUser);
//     setUser(normalized);
//     localStorage.setItem("user", JSON.stringify(normalized));
//   };

//   const logoutUser = async () => {
//     try {
//       await fetch(`${backendUrl}/signout`, {
//         method: "POST",
//         credentials: "include",
//       });
//     } catch (e) {
//       console.warn("Signout request failed:", e);
//     }
//     setUser(null);
//     localStorage.removeItem("user");
//   };

//   const userId = user?.id || user?._id || null;

//   return (
//     <UserContext.Provider
//       value={{ user, userId, updateUser, logoutUser, isUserLoaded }}
//     >
//       {children}
//     </UserContext.Provider>
//   );
// };







// update 10.15.24
// userContext.jsx
import { createContext, useState, useEffect } from "react";
import { backendUrl } from "./config";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isUserLoaded, setIsUserLoaded] = useState(false);

  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const normalizeUser = (rawUser) => {
    // If nothing passed (e.g., after logout), return null cleanly
    if (!rawUser || typeof rawUser !== "object") return null;

    const id =
      rawUser._id ||
      rawUser.id ||
      rawUser.userId ||
      rawUser.uid ||
      rawUser.sub ||
      null;

    // Normalize role into both userType AND usertype to avoid consumer crashes
    const resolvedRole =
      rawUser.usertype ||
      rawUser.userType ||
      rawUser.role ||
      rawUser.roles ||
      rawUser.type ||
      null;

    const tz =
      rawUser.timeZone && rawUser.timeZone !== "UTC"
        ? rawUser.timeZone
        : clientTimeZone;

    const normalized = {
      ...rawUser,
      // keep both for backward compatibility
      userType: resolvedRole,
      usertype: resolvedRole,
      timeZone: tz,
      id,
    };

    return normalized;
  };

  useEffect(() => {
    const stored = localStorage.getItem("user");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        const normalized = normalizeUser(parsed);
        setUser(normalized); // may be null if bad shape
      } catch {
        localStorage.removeItem("user");
        setUser(null);
      }
      setIsUserLoaded(true);
    } else {
      fetch(`${backendUrl}/current-user`, { credentials: "include" })
        .then((res) => {
          if (!res.ok) throw new Error("Not authenticated");
          return res.json();
        })
        .then(({ user: srvUser }) => {
          const normalized = normalizeUser(srvUser);
          if (normalized) {
            setUser(normalized);
            localStorage.setItem("user", JSON.stringify(normalized));
          } else {
            setUser(null);
          }
        })
        .catch((err) => {
          console.warn("Error fetching current user:", err);
          setUser(null);
        })
        .finally(() => setIsUserLoaded(true));
    }
  }, [backendUrl]); // include backendUrl just in case it changes

  const updateUser = (newUser) => {
    const normalized = normalizeUser(newUser);
    if (normalized) {
      setUser(normalized);
      localStorage.setItem("user", JSON.stringify(normalized));
    } else {
      setUser(null);
      localStorage.removeItem("user");
    }
  };

  const logoutUser = async () => {
    try {
      await fetch(`${backendUrl}/signout`, {
        method: "POST",
        credentials: "include",
      });
    } catch (e) {
      console.warn("Signout request failed:", e);
    }
    setUser(null);
    localStorage.removeItem("user");
  };

  const userId = user?.id || user?._id || null;

  return (
    <UserContext.Provider
      value={{ user, userId, updateUser, logoutUser, isUserLoaded }}
    >
      {children}
    </UserContext.Provider>
  );
};
















